import React from 'react';
import { Ruler, ShieldCheck, Settings, Wrench } from 'lucide-react';
export function Quality() {
  const features = [{
    title: 'Custom Fit',
    copy: 'Every panel is measured and fabricated for your opening instead of relying on a one-size-fits-most shower door.',
    icon: Ruler
  }, {
    title: 'Tempered Safety Glass',
    copy: 'Shower glass is built from durable tempered glass designed for strength, safety and long-term use.',
    icon: ShieldCheck
  }, {
    title: 'Better Hardware Details',
    copy: 'Hinges, clips, handles, towel bars and brackets should look good now and hold up under everyday bathroom use.',
    icon: Settings
  }, {
    title: 'Clean Installation',
    copy: 'Professional installation helps avoid poor fit, excess caulk, uneven gaps and other issues that make a shower look unfinished.',
    icon: Wrench
  }];
  return <section className="py-20 bg-gray-50" data-id="element-1467" data-mp="2rvjvakuittr9">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1468" data-mp="2rwcxr9mg5x3l">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1469" data-mp="3f0chd5muc3h4">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1470" data-mp="3a19b5hv4jr7k">
            Quality Glass, Quality Hardware & Professional Installation
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1471" data-mp="3jynov9pny1w6">
            A great-looking glass shower enclosure depends on three things: the
            right glass, the right hardware and the right installation. Kosin's
            Glass focuses on custom measurements, premium tempered glass,
            quality hardware, clean details and professional installation so
            your shower looks finished and functions properly.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1472" data-mp="6l2h832ih8bz">
          {features.map((feature, i) => <div key={i} className="bg-white p-8 rounded-lg shadow-card border border-gray-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1473" data-mp="2dah5le5thhk1" data-mpi={i}>
              <div className="w-12 h-12 bg-glass rounded-lg flex items-center justify-center mb-6 text-primary" data-id="element-1474" data-mp="h6t04sw6gx19">
                <feature.icon className="w-6 h-6" data-id="element-1475" data-mp="l8efqm03jpf5" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1476" data-mp="q7r3ra2pf2jb">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1477" data-mp="v7dfff2vwaq0">{feature.copy}</p>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mb-8 anim-on-scroll" data-id="element-1478" data-mp="104wu2g3hupih">
          <div className="bg-white border-l-4 border-primary rounded-lg p-5 shadow-sm" data-id="element-1479" data-mp="14wnbf60umdje">
            <p className="text-navy text-sm md:text-base leading-relaxed" data-id="element-1480" data-mp="14z14j9byxfob">
              <span className="font-semibold" data-id="element-1481" data-mp="18xgv1n79d66h">
                Why local homeowners choose Kosin's Glass:
              </span>{' '}
              custom shower glass depends on precise measurement, quality
              hardware and clean installation. We bring all three to every
              project across Southeast Michigan.
            </p>
          </div>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1482" data-mp="1o08o91a8rfx9">
          <a href="#quote" className="inline-flex items-center justify-center bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-lg transition-colors" data-id="element-1483" data-mp="1j2740d12xak7">
            Get a Professional Shower Door Quote
          </a>
        </div>
      </div>
    </section>;
}